var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"route-page"},[_c('div',{staticClass:"route-header"},[_vm._v("Trade")]),_c('div',{staticClass:"route-body"},[_vm._v("Trading View"),_c('br'),_vm._v("Coming Soon")])])
}]

export { render, staticRenderFns }